import { ISetPage } from '../../actions/helper';
import { HELPER_SET_PAGE_ACTION_TYPE } from '../../constants/actionTypes';
import { IConfigHelper } from '../../types/helper';
import { TReduxActions } from '../../types/redux';

const defaultState: IConfigHelper = {
  page: 'main',
};

export function helperReducer(state: IConfigHelper = defaultState, action: TReduxActions) {
  if (action.type === HELPER_SET_PAGE_ACTION_TYPE) {
    return {
      ...state,
      page: (action as ISetPage).page,
      breadcrumbs: (action as ISetPage).breadcrumbs,
    };
  }

  return state;
}
